import { EDITOR_CONTENT } from 'components/Layout/NoteView'

import { plugins as BaseEditorPlugins } from './EditorPlugins'
import makeLinkPlugin from './link'
import makeMentionPlugin from './mention'
import makeNoteLinkPlugin from './NoteLinkPublicPlugin'

export default async ({
  iframelyApiKey,
  createInfoToasterMessage,
  getFullNotePath,
  isEditable = true,
  publicChannelId = null,
  hasEditorNextFeatureFlag = false,
} = {}) => {
  const SliteEditorPlugins = hasEditorNextFeatureFlag
    ? (await import(/* webpackChunkName: "editor-next" */ './EditorNextPlugins'))
        .plugins
    : BaseEditorPlugins

  return Promise.all([
    SliteEditorPlugins.CollaborationPlugin(),
    SliteEditorPlugins.CrashPlugin(),
    SliteEditorPlugins.CorePlugin(),
    !publicChannelId ? SliteEditorPlugins.FullWidthPlugin() : [],
    isEditable ? SliteEditorPlugins.DndPlugin() : [],
    SliteEditorPlugins.CommandPickerPlugin(),
    SliteEditorPlugins.EmojiPickerPlugin(),
    SliteEditorPlugins.BlockquotePlugin(),
    SliteEditorPlugins.CodePlugin(),
    SliteEditorPlugins.HintPlugin(),
    SliteEditorPlugins.PlaceholderPlugin(),
    SliteEditorPlugins.ImageGalleryPlugin(),
    SliteEditorPlugins.ImagePlugin({ enableLightbox: true }),
    makeMentionPlugin({ MentionPlugin: SliteEditorPlugins.MentionPlugin })(),
    makeNoteLinkPlugin({ NoteLinkPlugin: SliteEditorPlugins.NoteLinkPlugin })({
      publicChannelId,
    }),
    SliteEditorPlugins.FilePlugin(),
    SliteEditorPlugins.TodoPlugin(),
    SliteEditorPlugins.LineBreakPlugin(),
    SliteEditorPlugins.TablePlugin(),
    makeLinkPlugin({ LinkPlugin: SliteEditorPlugins.LinkPlugin })({
      isEditable,
    }),
    SliteEditorPlugins.SeparatorPlugin(),
    SliteEditorPlugins.EmbedPlugin({ enableLightbox: true, iframelyApiKey }),
    SliteEditorPlugins.RichTextPlugin(),
    SliteEditorPlugins.HighlightPlugin(),
    SliteEditorPlugins.TypingPlugin(),
    SliteEditorPlugins.LastLinePlugin(),
    SliteEditorPlugins.ToolbarPlugin({ containerId: EDITOR_CONTENT }),
    isEditable ? SliteEditorPlugins.BlockActionPlugin() : [],
    SliteEditorPlugins.IntegrationTilePlugin(),
    SliteEditorPlugins.LightboxPlugin(),
    SliteEditorPlugins.PdfPlugin(),
    SliteEditorPlugins.ToastPlugin(createInfoToasterMessage),
    SliteEditorPlugins.ClipboardPlugin({ getFullNotePath }),
    SliteEditorPlugins.UnknownBlockPlugin(),
  ])
}
